import importerReducers from 'modules/shared/importer/importerReducers';
import actions from 'modules/eboxModule/importer/eboxModuleImporterActions';

export default importerReducers(actions);
